import CompaniesPage from "../features/crm/CompaniesPage";

export default function CompaniesRoute() {
  return <CompaniesPage />;
}
